import React, { useEffect, useRef, useState } from "react";

// plugin imports
import { Link, useTranslation } from "@herob191/gatsby-plugin-react-i18next";
import { useStaticQuery, graphql } from "gatsby";
import { motion } from "motion/react";
import Lottie from "lottie-react";

// style imports
import "./Header.scss";

// context imports

// component imports

// util imports
import { fade } from "../../utils/animations";
import BorderArrowButton from "../BorderArrowButton/BorderArrowButton";

// svg imports
// import Logo from "../../svg/logotype.svg";

// lotie imports
import LogoLottie from "../../lottie/logo.json";

// component

export const Header = () => {
	const { t, i18n } = useTranslation();

	const data = useStaticQuery(graphql`
		query HeaderQuery {
			allMarkdownRemark {
				nodes {
					frontmatter {
						title
						slug
					}
					parent {
						... on File {
							name
						}
					}
				}
			}
			companyJson {
				name
			}
		}
	`);

	const logoRef = useRef(null);
	const play = (lottieRef) => {
		lottieRef?.current?.setSpeed(1);
		lottieRef?.current?.setDirection(1);
		lottieRef?.current?.play();
	};
	const rewind = (lottieRef) => {
		lottieRef?.current?.setSpeed(0.5);
		lottieRef?.current?.setDirection(-1);
		lottieRef?.current?.play();
	};
	useEffect(() => {
		window?.addEventListener("scroll", () => {
			if (window?.scrollY < 50) {
				rewind(logoRef);
			} else {
				play(logoRef);
			}
		});
	});

	const currentLanguage = i18n.language;
	const navLinks = data.allMarkdownRemark.nodes
		.filter((node) => {
			const nameParts = node.parent.name.split(".");
			const fileLang =
				nameParts.length > 1 ? nameParts[nameParts.length - 1] : "es";
			return fileLang === currentLanguage;
		})
		.sort((a, b) => a.parent.name.localeCompare(b.parent.name));

	const companyName = data.companyJson?.name || "IPG";

	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};
	React.useEffect(() => {
		if (typeof document !== undefined && typeof window !== undefined) {
			if (isMenuOpen) {
				// We want a fixed body;
				document.body.style.top = `-${window.scrollY}px`;
				document.body.style.position = "fixed";
				document.body.style.overflowY = "scroll";
				document.documentElement.style.scrollBehavior = "auto";
			} else {
				const scrollY = document.body.style.top;
				const windowScroll = `-${window.scrollY}px`;
				// console.log(scrollY);
				// console.log(windowScroll);
				document.body.style.position = "";
				document.body.style.top = "";
				window.scrollTo(0, parseInt(scrollY || windowScroll || "0") * -1);
				document.documentElement.style.scrollBehavior = "";
			}
		}
	}, [isMenuOpen]);

	const MenuLink = ({ to, text }) => {
		return (
			<Link
				to={to}
				className="menuLink h1"
				activeClassName="active"
				onClick={() => {
					toggleMenu();
				}}
			>
				<BorderArrowButton>{text}</BorderArrowButton>
			</Link>
		);
	};

	return (
		<>
			<Link
				to="/"
				className="navLogo"
				aria-label={`${companyName} - ${t("Inicio")}`}
			>
				<Lottie
					lottieRef={logoRef}
					animationData={LogoLottie}
					loop={false}
					autoplay={false}
				/>
				{/* <Logo /> */}
			</Link>
			<header className="header">
				<div className="headerInner">
					{isMenuOpen && (
						<motion.button
							{...fade}
							className="navMenuBg"
							onClick={toggleMenu}
						/>
					)}
					<motion.nav
						initial={false}
						animate={{
							x: isMenuOpen ? 0 : "100%",
							transition: { duration: isMenuOpen ? 1 : 0.5, ease: "circOut" },
						}}
						className={`navMenu ${isMenuOpen ? "open" : ""}`}
					>
						{navLinks.map((link, i) => (
							<MenuLink
								key={"menuLink" + i}
								to={link.frontmatter.slug}
								text={link.frontmatter.title}
							/>
						))}
					</motion.nav>

					<button
						className={`menuButton ${isMenuOpen ? "menuOpen" : ""}`}
						aria-label={isMenuOpen ? t("Cerrar menú") : t("Abrir menú")}
						aria-expanded={isMenuOpen}
						onClick={toggleMenu}
					>
						<span className="line"></span>
						<span className="line"></span>
					</button>
				</div>
			</header>
		</>
	);
};
